export const CURRENT_BOT = 'https://bots.mb.ukrgasbank.com'
export const NEW_BOT = 'https://ecochatbots.s3.eu-central-1.amazonaws.com/new_testbots/index.html'